import { type Config, config } from "@repo/config";
import { createPurchasesHelper } from "@repo/payments/lib/helper";
import { usePurchasesQuery } from "@saas/payments/lib/api";

const plans = config.payments.plans as Config["payments"]["plans"];

export const usePurchases = (organizationId?: string) => {
	const {
		data: purchasesData,
		isLoading,
		isError,
	} = usePurchasesQuery(organizationId);

	// 确保purchases是数组
	const purchases = Array.isArray(purchasesData) ? purchasesData : [];
	const {
		activePlan,
		hasSubscription,
		hasPurchase,
		canRemoveWatermark,
		planTier,
	} = createPurchasesHelper(purchases as any);

	return {
		purchases,
		activePlan,
		hasSubscription,
		hasPurchase,
		canRemoveWatermark,
		planTier,
		loading: isLoading,
		// 请求失败时 purchases 是空数组，看起来和没付过钱一样，要分辨就看它
		isError,
	};
};

export const useUserPurchases = () => usePurchases();

export const useOrganizationPurchases = (organizationId: string) =>
	usePurchases(organizationId);
